import { z } from 'zod';
import { Currency } from '../enums/currency.enum';
import { DistanceUnit } from '../enums/distance-unit.enum';

// ============================================================================
// LENIENT SCHEMA (for deserialization)
// ============================================================================
const lenientUnitsNodeSchema = z.object({
  currency: z.nativeEnum(Currency),
  odometer: z.nativeEnum(DistanceUnit),
}).transform(val => ({
  currency: val.currency,
  odometer: val.odometer,
}));

// ============================================================================
// STRICT SCHEMA (for validation)
// ============================================================================
const strictUnitsNodeSchema = z.object({
  currency: z.nativeEnum(Currency, { errorMap: () => ({ message: 'Invalid currency' }) }),
  odometer: z.nativeEnum(DistanceUnit, { errorMap: () => ({ message: 'Invalid distance unit' }) }),
}).transform(val => ({
  currency: val.currency,
  odometer: val.odometer,
}));

// ============================================================================
// TYPE
// ============================================================================
export type UnitsNode = z.infer<typeof lenientUnitsNodeSchema>;

// ============================================================================
// NAMESPACE (for Methods)
// ============================================================================
export namespace UnitsNode {
  export function deserialize(data: unknown): UnitsNode {
    return lenientUnitsNodeSchema.parse(data);
  }

  export function create(data: unknown): UnitsNode {
    return strictUnitsNodeSchema.parse(data);
  }

  /**
   * Create default units (GBP and Miles)
   */
  export function createDefault(): UnitsNode {
    return {
      currency: Currency.GBP,
      odometer: DistanceUnit.MILES,
    };
  }
}
